import { render, staticRenderFns } from "./ConfirmationPix.vue?vue&type=template&id=1eb6026e&"
import script from "./ConfirmationPix.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports